import Modal from "react-modal";
import { Link } from "react-router-dom";
import "../../../styles/Buttons.css";
import "../../../styles/Containers.css";
import "../../../styles/DatePicker.css";
import { useState } from "react";
import { DatePicker } from "react-advance-jalaali-datepicker";
import { useFetch } from "../../../custom/api";
import { toast } from "react-toastify";

import persian from "react-date-object/calendars/persian.js";
// import gregorian from "react-date-object/locales/gregorian_en.js";
import DateObject from "react-date-object";
// var  = require("date-object/calendars/cjs/gregorian");

function formatDate(date) {
  const ff = new Date(date * 1000).toISOString().substring(0, 10);
  return ff;
}
export default function DateModal({
  showModal,
  handleCloseModal,
  loading,
  emptyDate1Error,
  emptyDate2Error,
  setRand,
}) {
  const { myFetch } = useFetch();
  let todayEnglish = new Date();
  let sevenDaysEnglish = new Date().setDate(new Date().getDate() + 7);
  let todayFormatted = todayEnglish.toISOString().substring(0, 10);
  let sevenDaysFormatted = new Date(sevenDaysEnglish)
    .toISOString()
    .substring(0, 10);

  let sevenDaysFormattedFarsi = new DateObject({
    date: new Date(sevenDaysEnglish),
  })
    .setCalendar(persian)
    .format("YYYY-MM-DD");

  let todayFormattedFarsi = new DateObject({
    date: new Date(),
  })
    .setCalendar(persian)
    .format("YYYY-MM-DD");

  const [startDate, setStartDate] = useState(todayFormatted);
  const [endDate, setEndDate] = useState(sevenDaysFormatted);

  async function handleSubmit() {
    let response = await myFetch("grocery/calendar", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        start_date: startDate,
        end_date: endDate,
      }),
    });

    let jsonResponse = await response.json();
    if (jsonResponse.status === "success") {
      toast.success(jsonResponse.message);
      setRand(Math.random());
    } else {
      toast.error(jsonResponse.message);
    }
    handleCloseModal();
  }

  function changeStart(unix, formatted) {
    setStartDate(formatDate(unix));
  }
  function changeEnd(unix, formatted) {
    setEndDate(formatDate(unix));
  }
  function DatePickerInput(props) {
    return <input className="subject-1 grey-1 b-grey-5" {...props} />;
  }

  return (
    <>
      <Modal
        isOpen={showModal}
        onRequestClose={handleCloseModal}
        contentLabel="Date Picker Modal"
        className="modal"
        overlayClassName="overlay"
      >
        <div className="modal-header">
          <h2>تاریخ شروع و پایان رو انتخاب کن</h2>
          <Link to="" onClick={handleCloseModal}>
            <span className="icon-iconclose b-white heading-1"></span>
          </Link>
        </div>
        <div className="modal-body">
          <div>
            <div className="box32"></div>

            <p className="grey-2 yekan">
              مواد اولیه غذاهای کدوم بازه از تقویم رو میخوای؟ <br />( نهایتا 14
              روز )
            </p>

            {/* <div className="flex">
            <button className="tag yekan">تا 7 روز آینده</button>
            <button className="tag yekan">تا 14 روز آینده</button>
          </div> */}
          </div>
          <div className="box32"></div>

          <p className="yekan">از تاریخ :</p>
          <DatePicker
            inputComponent={DatePickerInput}
            placeholder="انتخاب تاریخ"
            format="jYYYY-jMM-jDD"
            onChange={changeStart}
            id="datePicker"
            preSelected={todayFormattedFarsi}
            containerClass={"grey-1"}
            customClass={"datepicker"}
          />

          {emptyDate1Error && <p className="error">{emptyDate1Error}</p>}

          <div className="box32"></div>
          <p className="yekan">تا تاریخ :</p>
          <DatePicker
            inputComponent={DatePickerInput}
            placeholder="انتخاب تاریخ"
            format="jYYYY-jMM-jDD"
            onChange={changeEnd}
            id="datePicker"
            preSelected={sevenDaysFormattedFarsi}
          />

          {emptyDate2Error && <p className="error">{emptyDate2Error}</p>}
          <div className="box32"></div>
        </div>
        <div className="modal-footer">
          <Link
            to=""
            onClick={handleSubmit}
            className="fill-container radius1-5"
            disabled={loading}
          >
            {loading ? "در حال پردازش..." : "سبد خرید رو بساز"}
          </Link>
        </div>
      </Modal>
    </>
  );
}
